/* LaterEgo — Istruzioni Personali — client script
   ----------------------------------------------------
   Caricato da: templates/page.istruzioni-personali.liquid
   Endpoint:    https://zbvwqlvzpschsmivjksd.supabase.co/functions/v1/get_instructions_by_token
   Auth:        token nella query string (?token=...) — il token È l'auth.
                ANON_KEY pubblica legacy (safe client-side).
*/
(function () {
  'use strict';
 
  // ============ CONFIG ============
  var SUPABASE_URL = 'https://zbvwqlvzpschsmivjksd.supabase.co';
  // ANON KEY public Legacy da interfaccia Supabase (progetto:LaterEgo) 
  var ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpidndxbHZ6cHNjaHNtaXZqa3NkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYzNDQxNjAsImV4cCI6MjA5MTkyMDE2MH0.KtZ42oDUV15BILcivSzlgUme-HegGuWoEk7fIzuupQw';
  var ENDPOINT = SUPABASE_URL + '/functions/v1/get_instructions_by_token';
 
  // ============ DOM HELPERS ============
  function $(id) { return document.getElementById(id); }
 
  function showError(msg) {
    var l = $('le-ip-loading'), s = $('le-ip-success'), e = $('le-ip-error'), em = $('le-ip-error-msg');
    if (l) l.style.display = 'none';
    if (s) s.style.display = 'none';
    if (e) e.style.display = 'block';
    if (em && msg) em.textContent = msg;
  }
 
  function showSuccess() {
    var l = $('le-ip-loading'), s = $('le-ip-success'), e = $('le-ip-error');
    if (l) l.style.display = 'none';
    if (e) e.style.display = 'none';
    if (s) s.style.display = 'block';
  }
 
  // ============ TOKEN EXTRACTION ============
  function getToken() {
    try {
      var params = new URLSearchParams(window.location.search);
      var t = params.get('token');
      return t ? String(t).trim() : '';
    } catch (e) {
      return '';
    }
  }
 
  function isValidToken(t) {
    return typeof t === 'string' && /^[A-Za-z0-9]{20,64}$/.test(t);
  }
 
  // ============ MAIN ============
  function init() {
    var token = getToken();
 
    if (!token) {
      showError('Manca il codice di accesso nel link. Riscansiona il QR e dovrebbe funzionare.');
      return;
    }
    if (!isValidToken(token)) {
      showError('Il codice di accesso non sembra valido. Verifica di aver scansionato il QR giusto.');
      return;
    }
 
    fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': ANON_KEY,
        'Authorization': 'Bearer ' + ANON_KEY
      },
      body: JSON.stringify({ token: token })
    })
    .then(function (r) {
      if (!r.ok) {
        var err = new Error('http_' + r.status);
        err.status = r.status;
        throw err;
      }
      return r.json();
    })
    .then(function (data) {
      if (!data || !data.ok) {
        throw new Error('invalid_response');
      }
      renderSuccess(data);
    })
    .catch(function (err) {
      try { console.error('[istruzioni-personali]', err); } catch (e) {}
      if (err && err.status === 404) {
        showError('Questo codice non risulta nel nostro sistema. Se hai appena ricevuto il pacco, riprova tra qualche minuto.');
      } else if (err && err.status === 401) {
        showError('Accesso non autorizzato. Se il problema persiste, scrivici.');
      } else {
        showError('Non riusciamo a recuperare le istruzioni in questo momento. Riprova tra poco — se persiste, scrivici.');
      }
    });
  }
 
  function renderSuccess(data) {
    var urls = data.urls || {};
    var $preview = $('le-ip-preview');
    var $pdf = $('le-ip-pdf');
    var $bom = $('le-ip-bom');
    var $meta = $('le-ip-meta');
 
    if ($preview) {
      if (urls.render_preview) {
        $preview.src = urls.render_preview;
      } else {
        $preview.style.display = 'none';
      }
    }
    if ($pdf) {
      if (urls.instructions_pdf) {
        $pdf.href = urls.instructions_pdf;
      } else if (urls.instructions_html) {
        $pdf.href = urls.instructions_html;
        $pdf.textContent = 'Apri le istruzioni';
      } else {
        $pdf.style.display = 'none';
      }
    }
    if ($bom) {
      if (urls.bom_csv) {
        $bom.href = urls.bom_csv;
      } else {
        $bom.style.display = 'none';
      }
    }
    if ($meta) {
      var html = '';
      if (data.order_number) {
        html += '<strong>Ordine:</strong> ' + escapeHtml(String(data.order_number)) + '<br>';
      }
      if (data.token_created_at) {
        try {
          var d = new Date(data.token_created_at);
          if (!isNaN(d.getTime())) {
            html += '<strong>Creato:</strong> ' + d.toLocaleDateString('it-IT');
          }
        } catch (e) {}
      }
      if (html) $meta.innerHTML = html;
    }
 
    showSuccess();
  }
 
  function escapeHtml(s) {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
 
  // ============ BOOT ============
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();